import { useLayoutEffect, useRef, useState, type HTMLAttributes } from 'react';
import { useReducedMotion } from './useReducedMotion';
import './StationaryPresence.css';

/** A page handoff without moving its data. Place sibling pages in one relative container. */
export function StationaryPresence({ show, children, keepMounted = false, className = '', style, ...props }: HTMLAttributes<HTMLDivElement> & { show: boolean; keepMounted?: boolean }) {
  const reduced = useReducedMotion();
  const [present, setPresent] = useState(show);
  const retained = useRef(children);
  if (show) retained.current = children;
  useLayoutEffect(() => {
    if (show) { setPresent(true); return undefined; }
    if (reduced) { setPresent(false); return undefined; }
    const timer = setTimeout(() => setPresent(false), 160);
    return () => clearTimeout(timer);
  }, [show, reduced]);
  if (!show && !present && !keepMounted) return null;
  return <div {...props} className={`stationary-presence ${className}`} data-open={show}
    style={{ position: show ? 'relative' : 'absolute', ...(!show ? { inset: 0, overflow: 'hidden' } : {}), ...style }}
    hidden={!show && !present} aria-hidden={!show} inert={!show}>
    {show || keepMounted ? children : retained.current}
  </div>;
}
